import { createAxiosServiceInstance } from '../api';
import { AMLS_NS_COMMON } from '../../pages/constants/globalConstants';
import { apiConfig } from '../apiConfig';

const axios = createAxiosServiceInstance();
const COMMON_MODULE_URL = `${apiConfig.serviceApi}${AMLS_NS_COMMON}/modules`;
const headers = {
  'Content-Type': 'application/json'
};

export async function getNSCommonModulesService() {
  return await axios.get(COMMON_MODULE_URL, { headers });
}
